<template>
  <div class="weather-head" v-if="item?.first">
    <div class="weather-cover" :class="item.season">
      <div class="weather-caption">{{ item.caption }}</div>
      <div class="weather-first">
        <div class="weather-first-icon">
          <img :src="weatherIcon(item.first.weather?.[0]?.icon, true)" alt="icon" />
        </div>
        <div class="weather-first-info">
          <div class="weather-first-temp">{{ item.first.main?.temp }}<span class="degree"></span></div>
          <div class="weather-first-wind" v-if="item.first.wind?.speed">{{ item.first.wind?.speed }} m/s</div>
        </div>
      </div>
    </div>

    <div class="weather-list">
      <div class="weather-item" v-for="(cast, index) in item.casts" :key="index">
        <div class="weather-item-time">{{ cast.time }}</div>
        <div class="weather-item-icon">
          <img :src="weatherIcon(cast.weather?.[0]?.icon)" alt="icon" />
        </div>
        <div class="weather-item-temp">{{ cast.main?.temp }}<span class="degree"></span></div>
        <div class="weather-item-wind" v-if="cast.wind?.speed">{{ cast.wind.speed }} m/s</div>
      </div>
    </div>
  </div>
</template>

<script setup>
const rIcons = import.meta.glob('@/assets/feed/weather/weather/*', { eager: true, import: 'default' });
const rIconsOutline = import.meta.glob('@/assets/feed/weather/weather-outline/*', { eager: true, import: 'default' });

defineProps({
  item: {
    type: Object,
    default: () => ({})
  }
});

function weatherIcon(name, outline = false) {
  if (!name) return '';
  const key = `/src/assets/feed/weather/${outline ? 'weather-outline' : 'weather'}/${name}.png`;
  return outline ? rIconsOutline[key] || '' : rIcons[key] || '';
}
</script>

<style scoped>
.degree::before {
  content: '\00B0';
}

.weather-head {
  display: flex;
  border: 1px solid rgba(224, 224, 224, 0.5);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.weather-cover {
  position: relative;
  min-height: 258px;
  flex: 1 1 auto;
  background-size: cover;
  background-position: center;
}

.weather-cover.winter {
  background-image: url('@/assets/feed/weather/seasons/winter.jpg');
}

.weather-cover.spring {
  background-image: url('@/assets/feed/weather/seasons/spring.jpg');
}

.weather-cover.summer {
  background-image: url('@/assets/feed/weather/seasons/summer.jpg');
}

.weather-cover.autumn {
  background-image: url('@/assets/feed/weather/seasons/autumn.jpg');
}

.weather-caption {
  position: absolute;
  top: 16px;
  right: 16px;
  left: 50%;
  color: #fff;
  text-align: right;
  font-size: 16px;
}

.weather-first {
  position: absolute;
  right: 16px;
  top: 55%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: #fff;
}

.weather-first-icon {
  width: 48px;
}

.weather-first-icon img {
  width: 100%;
}

.weather-first-info {
  margin-left: 16px;
  text-align: right;
}

.weather-first-temp {
  font-size: 32px;
}

.weather-first-wind {
  font-size: 14px;
  margin-top: 4px;
  font-weight: 700;
}

.weather-list {
  width: 320px;
  padding: 16px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.weather-item {
  text-align: center;
  color: #777;
  font-size: 14px;
}

.weather-item-time {
  font-size: 12px;
}

.weather-item-icon {
  width: 32px;
  margin: 4px auto;
}

.weather-item-icon img {
  width: 100%;
}

.weather-item-wind {
  font-size: 12px;
  margin-top: 2px;
}

@media (max-width: 768px) {
  .weather-head {
    flex-direction: column;
  }

  .weather-cover {
    min-height: 220px;
  }

  .weather-list {
    width: 100%;
  }
}
</style>
